import { Bomb, CircleDot, Coins, Diamond, Dice5, Grid3x3, Rocket, Spade, Triangle } from 'lucide-react';

// Unreleased games have no route; galleries render them as locked previews.
export const originalGames = [
  { id: 'keno', name: 'Keno', to: '/games/keno', icon: Grid3x3, available: true },
  { id: 'blackjack', name: 'Blackjack', to: '/games/blackjack', icon: Spade, available: true },
  { id: 'mines', name: 'Mines', to: '/games/mines', icon: Bomb, available: true },
  { id: 'limbo', name: 'Limbo', to: '/games/limbo', icon: Rocket, available: true },
  { id: 'dice', name: 'Dice', to: '/games/dice', icon: Dice5, available: true },
  { id: 'plinko', name: 'Plinko', to: '/games/plinko', icon: Triangle, available: true },
  { id: 'coinflip', name: 'Coinflip', icon: Coins, available: false },
  { id: 'roulette', name: 'Roulette', icon: CircleDot, available: false },
  { id: 'baccarat', name: 'Baccarat', icon: Diamond, available: false },
];